
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _401LRf7Hdx8meeMyJIyapNLiYkmgQlciD2ZM4wj2BieJMsMeta } from "/app/pages/401.vue?macro=true";
import { default as _500EOXM_S6s26Hwizk1bVS_pPKbpG5aPEfzQgvAFCP_CCkMeta } from "/app/pages/500.vue?macro=true";
import { default as errormwD7kY_BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_IMeta } from "/app/pages/error.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_7f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as a_45proposWPUib8yA_bTvyQZr_IHrRCENs5DhDLhfd_PiLGQUbtgMeta } from "/app/pages/a-propos.vue?macro=true";
import { default as recoveryjvdMuf4tj65v1Fz6s3SfthniQBZUmrHtRRdl7CaxaDwMeta } from "/app/pages/recovery.vue?macro=true";
import { default as _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_65xuuMFULoZbO_183vt2UD8Meta } from "/app/pages/[...slug].vue?macro=true";
import { default as indexRFwbK8a_T41OpmzkIV4wsLJoCD_3vDDnoRzf1R3_Bj8Meta } from "/app/pages/omra/index.vue?macro=true";
import { default as guidepuTAd79Kk3W6VPIlGI_o2z7u0Rm68QgoBEAwv_ef9b8Meta } from "/app/pages/admin/guide.vue?macro=true";
import { default as indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta } from "/app/pages/admin/index.vue?macro=true";
import { default as users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta } from "/app/pages/admin/users.vue?macro=true";
import { default as _91slug_93xDjo9peST0NES6Fy6rfpaY1Zab31CSRd5zsDlxs4dRwMeta } from "/app/pages/omra/[slug].vue?macro=true";
import { default as _91token_93Z_sLWPHV7tYruMebUETh18f7ifAKo7GAK8IsTPgH_7YMeta } from "/app/pages/pay/[token].vue?macro=true";
import { default as guidesgRZ5eX53pkNFzdxNmd_nyT7AKVb_Nu86e_rJJ_2QhNEMeta } from "/app/pages/admin/guides.vue?macro=true";
import { default as hotelsNj8IvXWeOeoID0IHqj81Ndktyh8HK09_3psC5Q0G9DEMeta } from "/app/pages/admin/hotels.vue?macro=true";
import { default as signin3_Kv94OdTvrpygXJbW_be9hptNNJmK6m_n3QMNk6n5YMeta } from "/app/pages/admin/signin.vue?macro=true";
import { default as auth_45success_8mfj2HRC5mm_IlWBRX1gGiT2wEbzX_LkDkEt159erMMeta } from "/app/pages/auth-success.vue?macro=true";
import { default as verificationHc4_WtTHNeJHTq_hExFlWnketobrEaAOES0aHm7waZkMeta } from "/app/pages/verification.vue?macro=true";
import { default as couponsH82Q7l6Fq5370oi_xDB_8XHTSi_hVddrZTCerfAVrK4Meta } from "/app/pages/admin/coupons.vue?macro=true";
import { default as profilemhfab3W7obQQBZRpbadeXy8hCOyQJRkxQmQl6UBklZ8Meta } from "/app/pages/admin/profile.vue?macro=true";
import { default as reportsobl9gFceYZYm_as9afJP0H22Yjh56xIaQK8JVHXUh9cMeta } from "/app/pages/admin/reports.vue?macro=true";
import { default as callback5612lXLe4PZ631CXyrAGAPjgqA1BpPfZdmbAAjaiuqIMeta } from "/app/pages/auth/callback.vue?macro=true";
import { default as indexB59nTb3qiRH3koS5I20w3WY3CrffkaFCWctD9MS9j3cMeta } from "/app/pages/epargne/index.vue?macro=true";
import { default as airlinesBkQuz42QBB19FZOgX2ro2XfeCMomMmfo24AlTlS8qdsMeta } from "/app/pages/admin/airlines.vue?macro=true";
import { default as settingsjpINHYWlqSsBB0Ri3ol_ZETwEd_od9UBgDjfk0FEzswMeta } from "/app/pages/admin/settings.vue?macro=true";
import { default as reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_FM1ScN8_pgMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as inventorytPQ8ueK129bB9gIYWQlQL8omiSx6dqwj8vSup9V6uu4Meta } from "/app/pages/admin/inventory.vue?macro=true";
import { default as indexIX2K_DHXqznHy2JJaSqpdfjTg5JxB50z_hKwraFNGHsMeta } from "/app/pages/booking/payment/index.vue?macro=true";
import { default as successzInaxs743bTBvIqlfDzCqwEO8bVLHyDxSDqFWB28uzIMeta } from "/app/pages/booking/payment/success.vue?macro=true";
import { default as thank_45youzQOxDdjwUD5KXxlulqdpsykjzXNikuUgkTmcsmfmJBIMeta } from "/app/pages/booking/payment/thank-you.vue?macro=true";
import { default as paymentKPbQQNIbLs6LHCkIuQZaNiYHHzChcgrPG4LkLyOmL10Meta } from "/app/pages/booking/payment.vue?macro=true";
import { default as index_F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_gOWaGcoMeta } from "/app/pages/dashboard/index.vue?macro=true";
import { default as dashboardRfnwFN2Q_Awpo97dEuuHs0_Gnutzcz32nfih_iIOmW4Meta } from "/app/pages/guide/dashboard.vue?macro=true";
import { default as regles_45de_45sejoura_HXelMOr6RYVU6FEPXyNUeimeplLmGnH5odN8dXDPQMeta } from "/app/pages/regles-de-sejour.vue?macro=true";
import { default as index_7ADq_Ad2D5BBfwQSxcVszROS5O5YOx7RW6_TDyKH2cMeta } from "/app/pages/admin/holds/index.vue?macro=true";
import { default as new_45bookingss0ym_lX__rhRuNDW_cN6U8SQvr7eYpi5fXMFvz_TN4Meta } from "/app/pages/admin/new-booking.vue?macro=true";
import { default as _91id_93KwboTjLKKuNYiKoU_97BOiBJ06YJbFYk6ywllDOBzisMeta } from "/app/pages/admin/orders/[id].vue?macro=true";
import { default as profileCuAldp0WHTg49q5V7f7Xic5jm0WIFFPx2PMBiZzot1QMeta } from "/app/pages/dashboard/profile.vue?macro=true";
import { default as index_UsYHcPIQG9VbdHrWWGfhNNiXyZdXdAJLvvc4s9mH58Meta } from "/app/pages/admin/orders/index.vue?macro=true";
import { default as dossiers2677Xn_RW42VMd0kl5UY83aDVyxyHEAhN4E8xkwWB7IMeta } from "/app/pages/dashboard/dossiers.vue?macro=true";
import { default as paymentsoSGhbwDqCeGs1AGU6Gcv9C2_QQigAiZaFjSG7iPe6L4Meta } from "/app/pages/dashboard/payments.vue?macro=true";
import { default as _91id_93zO6BP71_hEFoKRtCmaBZo492dy4s4hwzTFk0oW0fg8MMeta } from "/app/pages/admin/bookings/[id].vue?macro=true";
import { default as notificationsRdPBgS1AKhJg0AuZvOV7Agk5Rpiytr86l28OP3hXP3wMeta } from "/app/pages/admin/notifications.vue?macro=true";
import { default as index9O_k_LE6qNJsH_k79AisIslgRclc7k1AQcRkmYmL6LkMeta } from "/app/pages/omra-ramadhan/index.vue?macro=true";
import { default as indexpmuTKYvWvtExnMot9ORqUr2zsFn333XM_RcziXpGVZQMeta } from "/app/pages/admin/packages/index.vue?macro=true";
import { default as _91id_93ik7XBjiqKz6erMadFzOuXjaLDRrW_z0c7Zp8ehZqB2IMeta } from "/app/pages/admin/travelers/[id].vue?macro=true";
import { default as epargne_45hajjSQstR9WCaP6kkqkcRGButwaYwsjMmr_o0TPcEFEaJ8EMeta } from "/app/pages/epargne/epargne-hajj.vue?macro=true";
import { default as epargne_45omraFHbu9zxO0dphM_XLNGZw_WMpCWSa0GxKTJ_IySEGz6YMeta } from "/app/pages/epargne/epargne-omra.vue?macro=true";
import { default as _91slug_93vctN6IPkhTtsKSw_rWDVALZhpYyVeHlt95HPYH09Z4YMeta } from "/app/pages/omra-ramadhan/[slug].vue?macro=true";
import { default as politique_45de_45cookiesF8PtLPRRDCAFknXv0uZKcNmbk_Tg8NgLISr8bEjW1WwMeta } from "/app/pages/politique-de-cookies.vue?macro=true";
import { default as questions_45frequentesmwvxeE2ykH2B_X5YHR7wHbkIU9CaA8TcdiBlwnNPfNMMeta } from "/app/pages/questions-frequentes.vue?macro=true";
import { default as indexYz_y3ajj721QFlMkE0Ld4B3bnFoIZmGprf_eH4JoKhcMeta } from "/app/pages/admin/documents/index.vue?macro=true";
import { default as indexuBkMWcMWr6xPqW8qWIvNzR0D609ZZtAyWsLh6HXZozkMeta } from "/app/pages/admin/travelers/index.vue?macro=true";
import { default as guideo0pUfMJYZ_mKgSaSwleIWqrfoYz0I0_qB6Yb_z5UsboMeta } from "/app/pages/booking-manager/guide.vue?macro=true";
import { default as indexmt6iy8CM59ezs_8QFp3zZkDWHRxZ_Dt3EOEz0KMFaoUMeta } from "/app/pages/booking-manager/index.vue?macro=true";
import { default as _91id_93HPlW04n38G_5_k3Fl9ZCKtSkx8KeN3rGqWWc3925YJgMeta } from "/app/pages/dashboard/orders/[id].vue?macro=true";
import { default as departure_45hotelsGc7NTmm4oO_f_TkHUpXhCwQM8IrsGa2AZPg_6hbygCAMeta } from "/app/pages/admin/departure-hotels.vue?macro=true";
import { default as indexC_ylYmZAB8Q5FrKxhPQ0oVn4MXN0FPesvcqKx_2fllUMeta } from "/app/pages/admin/departures/index.vue?macro=true";
import { default as guidesYHorA3JJ1eV2SJp_VBZmBlR93wwW1oXNJfoRdzB_GTcMeta } from "/app/pages/booking-manager/guides.vue?macro=true";
import { default as _91id_93KKcURwP6wpHAdKGQUzolVZWAvZhMFoWQ8KfpHYG84rQMeta } from "/app/pages/dashboard/dossier/[id].vue?macro=true";
import { default as indexkOvzk4Wqpubas5BmXm0ByupmjVQqBS_Yg1ah_XSHMmYMeta } from "/app/pages/dashboard/orders/index.vue?macro=true";
import { default as hotel_45assignmentsV8ol_Tk3G2vNyTWwR_WnE6Dk9BzAezZJN_0DScKcEhkMeta } from "/app/pages/admin/hotel-assignments.vue?macro=true";
import { default as couponsdUiqFCMDyn3uLCl0UMgt_RBYg4qeTVs_aw3NE_VHR1YMeta } from "/app/pages/booking-manager/coupons.vue?macro=true";
import { default as profileG3HeS8clMJ8_5GYBbBIpsfraDhh8jTDMbd4p2qJwTZUMeta } from "/app/pages/booking-manager/profile.vue?macro=true";
import { default as notificationsOf_UNAu7opNvb7bZhEzgiNcnefyxcJSYDqKrGSibnQQMeta } from "/app/pages/dashboard/notifications.vue?macro=true";
import { default as packages30l6sBzRUmjx4hTywKoRV0gOzn_y99_NCBt_mHp5tM4Meta } from "/app/pages/booking-manager/packages.vue?macro=true";
import { default as _91id_93Dr03uygKGplV_dpE9sB8_jBzBR69dNpfLlWtlfmOTJoMeta } from "/app/pages/dashboard/travelers/[id].vue?macro=true";
import { default as indexd_31UrK0larHekyt8oc8pkppJ8g6E1YuCF8wPuQcQSQMeta } from "/app/pages/dashboard/documents/index.vue?macro=true";
import { default as indexZ4zZlupNsyy5B7c0AnnGfrgRGQm6pEVPYYjvX10CkEEMeta } from "/app/pages/dashboard/travelers/index.vue?macro=true";
import { default as hotel_45assignments_45old0wncN4TyXcYYjK35OdJREINJCLaKNdU1_kLYNh6cnkEMeta } from "/app/pages/admin/hotel-assignments-old.vue?macro=true";
import { default as _91id_93vRf60Bqh9JWMgUARg_XTn5HeUxRI3Atxv7dBas134WMMeta } from "/app/pages/booking-manager/orders/[id].vue?macro=true";
import { default as indexqYBc0kRKjU6tTnunWrOk2rhdTpmtLf5pcsdJ6ajGRhQMeta } from "/app/pages/booking-manager/orders/index.vue?macro=true";
import { default as politique_45de_45confidentialite0jnOuzEMx5LIKce5uFIo714Is9atQrBbApO12FXIk7cMeta } from "/app/pages/politique-de-confidentialite.vue?macro=true";
import { default as notificationsIVb9miuOFMMf4CPWneiN3Pb_DF_mQQNKGca9kds6_ooMeta } from "/app/pages/booking-manager/notifications.vue?macro=true";
import { default as conditions_45generales_45de_45ventex1ITf_gzCzF9_cHTWgvq05VefcuG7VrzbJFozaD4xL8Meta } from "/app/pages/conditions-generales-de-vente.vue?macro=true";
import { default as _91id_93KIZt2_DN5fUcPrA3wUm6AOx1TEdw2yjNdWCq4VFyAksMeta } from "/app/pages/booking-manager/travelers/[id].vue?macro=true";
import { default as index2CM4ityJcoe7VQNVLPhvGTypZ4PKg_cmlHQgBvxcickMeta } from "/app/pages/booking-manager/documents/index.vue?macro=true";
import { default as indexcOc1u1ZSjUtcvVkEXCdvjzJOyQbQq2CPBQzbZtcC8tcMeta } from "/app/pages/booking-manager/travelers/index.vue?macro=true";
import { default as indexxTRY7vN5gRH4kR71CyuhZZJGojRd59SeRUhIhzO3n1cMeta } from "/app/pages/booking-manager/departures/index.vue?macro=true";
import { default as hotel_45assignmentsioSk6CxK9qSjHW_yRw7mHsg1pwECbfpjKrGyWwG3Fz0Meta } from "/app/pages/booking-manager/hotel-assignments.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationYdn9pwCbGK5wWClbDZU4DczSxf4aZGo0fyl7FTUfnxAMeta } from "/app/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as room_45assignmentsQqd6myEJMcgde6CkuEKY2fHVBInBG_d_vE2kywc89tsMeta } from "/app/pages/admin/departures/[id]/room-assignments.vue?macro=true";
import { default as room_45assignmentsHEANVeD45gCLwQzrmQ8q7Z2ejqp8eQRs8SZO8PfoiQwMeta } from "/app/pages/booking-manager/departures/[id]/room-assignments.vue?macro=true";
export default [
  {
    name: "401",
    path: "/401",
    meta: _401LRf7Hdx8meeMyJIyapNLiYkmgQlciD2ZM4wj2BieJMsMeta || {},
    component: () => import("/app/pages/401.vue")
  },
  {
    name: "500",
    path: "/500",
    meta: _500EOXM_S6s26Hwizk1bVS_pPKbpG5aPEfzQgvAFCP_CCkMeta || {},
    component: () => import("/app/pages/500.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: errormwD7kY_BU1_rHGEshIkO6bNB5B0luZiwF4k9TLpjX_IMeta || {},
    component: () => import("/app/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_FbxIMeta || {},
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "a-propos",
    path: "/a-propos",
    component: () => import("/app/pages/a-propos.vue")
  },
  {
    name: "recovery",
    path: "/recovery",
    meta: recoveryjvdMuf4tj65v1Fz6s3SfthniQBZUmrHtRRdl7CaxaDwMeta || {},
    component: () => import("/app/pages/recovery.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93QkkyEDg6xOGuFkoxzFC_65xuuMFULoZbO_183vt2UD8Meta || {},
    component: () => import("/app/pages/[...slug].vue")
  },
  {
    name: "omra",
    path: "/omra",
    meta: indexRFwbK8a_T41OpmzkIV4wsLJoCD_3vDDnoRzf1R3_Bj8Meta || {},
    component: () => import("/app/pages/omra/index.vue")
  },
  {
    name: "admin-guide",
    path: "/admin/guide",
    meta: { ...(guidepuTAd79Kk3W6VPIlGI_o2z7u0Rm68QgoBEAwv_ef9b8Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/guide.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexUTPWuOuTEHiifiH2gSDbviVYzY2wHbmPaccb9r89Io4Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/index.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: { ...(users0dvwj0GYikGWaRqGKQojuF0hl_wUB0ZSFJtbA1vtME8Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/users.vue")
  },
  {
    name: "omra-slug",
    path: "/omra/:slug()",
    meta: _91slug_93xDjo9peST0NES6Fy6rfpaY1Zab31CSRd5zsDlxs4dRwMeta || {},
    component: () => import("/app/pages/omra/[slug].vue")
  },
  {
    name: "pay-token",
    path: "/pay/:token()",
    meta: { ...(_91token_93Z_sLWPHV7tYruMebUETh18f7ifAKo7GAK8IsTPgH_7YMeta || {}), ...{"middleware":[]} },
    component: () => import("/app/pages/pay/[token].vue")
  },
  {
    name: "admin-guides",
    path: "/admin/guides",
    meta: { ...(guidesgRZ5eX53pkNFzdxNmd_nyT7AKVb_Nu86e_rJJ_2QhNEMeta || {}), ...{"middleware":"staff-only"} },
    component: () => import("/app/pages/admin/guides.vue")
  },
  {
    name: "admin-hotels",
    path: "/admin/hotels",
    meta: { ...(hotelsNj8IvXWeOeoID0IHqj81Ndktyh8HK09_3psC5Q0G9DEMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/hotels.vue")
  },
  {
    name: "admin-signin",
    path: "/admin/signin",
    component: () => import("/app/pages/admin/signin.vue")
  },
  {
    name: "auth-success",
    path: "/auth-success",
    meta: auth_45success_8mfj2HRC5mm_IlWBRX1gGiT2wEbzX_LkDkEt159erMMeta || {},
    component: () => import("/app/pages/auth-success.vue")
  },
  {
    name: "verification",
    path: "/verification",
    meta: verificationHc4_WtTHNeJHTq_hExFlWnketobrEaAOES0aHm7waZkMeta || {},
    component: () => import("/app/pages/verification.vue")
  },
  {
    name: "admin-coupons",
    path: "/admin/coupons",
    meta: { ...(couponsH82Q7l6Fq5370oi_xDB_8XHTSi_hVddrZTCerfAVrK4Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/coupons.vue")
  },
  {
    name: "admin-profile",
    path: "/admin/profile",
    meta: { ...(profilemhfab3W7obQQBZRpbadeXy8hCOyQJRkxQmQl6UBklZ8Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/profile.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(reportsobl9gFceYZYm_as9afJP0H22Yjh56xIaQK8JVHXUh9cMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/reports.vue")
  },
  {
    name: "auth-callback",
    path: "/auth/callback",
    meta: callback5612lXLe4PZ631CXyrAGAPjgqA1BpPfZdmbAAjaiuqIMeta || {},
    component: () => import("/app/pages/auth/callback.vue")
  },
  {
    name: "epargne",
    path: "/epargne",
    meta: indexB59nTb3qiRH3koS5I20w3WY3CrffkaFCWctD9MS9j3cMeta || {},
    component: () => import("/app/pages/epargne/index.vue")
  },
  {
    name: "admin-airlines",
    path: "/admin/airlines",
    meta: { ...(airlinesBkQuz42QBB19FZOgX2ro2XfeCMomMmfo24AlTlS8qdsMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/airlines.vue")
  },
  {
    name: "admin-settings",
    path: "/admin/settings",
    meta: { ...(settingsjpINHYWlqSsBB0Ri3ol_ZETwEd_od9UBgDjfk0FEzswMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/settings.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "admin-inventory",
    path: "/admin/inventory",
    meta: { ...(inventorytPQ8ueK129bB9gIYWQlQL8omiSx6dqwj8vSup9V6uu4Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/inventory.vue")
  },
  {
    name: paymentKPbQQNIbLs6LHCkIuQZaNiYHHzChcgrPG4LkLyOmL10Meta?.name,
    path: "/booking/payment",
    meta: paymentKPbQQNIbLs6LHCkIuQZaNiYHHzChcgrPG4LkLyOmL10Meta || {},
    component: () => import("/app/pages/booking/payment.vue"),
    children: [
  {
    name: "booking-payment",
    path: "",
    meta: indexIX2K_DHXqznHy2JJaSqpdfjTg5JxB50z_hKwraFNGHsMeta || {},
    component: () => import("/app/pages/booking/payment/index.vue")
  },
  {
    name: "booking-payment-success",
    path: "success",
    meta: successzInaxs743bTBvIqlfDzCqwEO8bVLHyDxSDqFWB28uzIMeta || {},
    component: () => import("/app/pages/booking/payment/success.vue")
  },
  {
    name: "booking-payment-thank-you",
    path: "thank-you",
    meta: thank_45youzQOxDdjwUD5KXxlulqdpsykjzXNikuUgkTmcsmfmJBIMeta || {},
    component: () => import("/app/pages/booking/payment/thank-you.vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index_F_uAQC8N4LTDgd1cq42C2ftJy11F_99xjd_gOWaGcoMeta || {},
    component: () => import("/app/pages/dashboard/index.vue")
  },
  {
    name: "guide-dashboard",
    path: "/guide/dashboard",
    meta: { ...(dashboardRfnwFN2Q_Awpo97dEuuHs0_Gnutzcz32nfih_iIOmW4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/guide/dashboard.vue")
  },
  {
    name: "regles-de-sejour",
    path: "/regles-de-sejour",
    component: () => import("/app/pages/regles-de-sejour.vue")
  },
  {
    name: "admin-holds",
    path: "/admin/holds",
    meta: {"middleware":"admin-only"},
    component: () => import("/app/pages/admin/holds/index.vue")
  },
  {
    name: "admin-new-booking",
    path: "/admin/new-booking",
    meta: new_45bookingss0ym_lX__rhRuNDW_cN6U8SQvr7eYpi5fXMFvz_TN4Meta || {},
    component: () => import("/app/pages/admin/new-booking.vue")
  },
  {
    name: "admin-orders-id",
    path: "/admin/orders/:id()",
    meta: _91id_93KwboTjLKKuNYiKoU_97BOiBJ06YJbFYk6ywllDOBzisMeta || {},
    component: () => import("/app/pages/admin/orders/[id].vue")
  },
  {
    name: "dashboard-profile",
    path: "/dashboard/profile",
    meta: profileCuAldp0WHTg49q5V7f7Xic5jm0WIFFPx2PMBiZzot1QMeta || {},
    component: () => import("/app/pages/dashboard/profile.vue")
  },
  {
    name: "admin-orders",
    path: "/admin/orders",
    meta: { ...(index_UsYHcPIQG9VbdHrWWGfhNNiXyZdXdAJLvvc4s9mH58Meta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/orders/index.vue")
  },
  {
    name: "dashboard-dossiers",
    path: "/dashboard/dossiers",
    meta: dossiers2677Xn_RW42VMd0kl5UY83aDVyxyHEAhN4E8xkwWB7IMeta || {},
    component: () => import("/app/pages/dashboard/dossiers.vue")
  },
  {
    name: "dashboard-payments",
    path: "/dashboard/payments",
    meta: paymentsoSGhbwDqCeGs1AGU6Gcv9C2_QQigAiZaFjSG7iPe6L4Meta || {},
    component: () => import("/app/pages/dashboard/payments.vue")
  },
  {
    name: "admin-bookings-id",
    path: "/admin/bookings/:id()",
    meta: { ...(_91id_93zO6BP71_hEFoKRtCmaBZo492dy4s4hwzTFk0oW0fg8MMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/bookings/[id].vue")
  },
  {
    name: "admin-notifications",
    path: "/admin/notifications",
    meta: { ...(notificationsRdPBgS1AKhJg0AuZvOV7Agk5Rpiytr86l28OP3hXP3wMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/notifications.vue")
  },
  {
    name: "omra-ramadhan",
    path: "/omra-ramadhan",
    meta: index9O_k_LE6qNJsH_k79AisIslgRclc7k1AQcRkmYmL6LkMeta || {},
    component: () => import("/app/pages/omra-ramadhan/index.vue")
  },
  {
    name: "admin-packages",
    path: "/admin/packages",
    meta: { ...(indexpmuTKYvWvtExnMot9ORqUr2zsFn333XM_RcziXpGVZQMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/packages/index.vue")
  },
  {
    name: "admin-travelers-id",
    path: "/admin/travelers/:id()",
    meta: _91id_93ik7XBjiqKz6erMadFzOuXjaLDRrW_z0c7Zp8ehZqB2IMeta || {},
    component: () => import("/app/pages/admin/travelers/[id].vue")
  },
  {
    name: "epargne-epargne-hajj",
    path: "/epargne/epargne-hajj",
    meta: epargne_45hajjSQstR9WCaP6kkqkcRGButwaYwsjMmr_o0TPcEFEaJ8EMeta || {},
    component: () => import("/app/pages/epargne/epargne-hajj.vue")
  },
  {
    name: "epargne-epargne-omra",
    path: "/epargne/epargne-omra",
    meta: epargne_45omraFHbu9zxO0dphM_XLNGZw_WMpCWSa0GxKTJ_IySEGz6YMeta || {},
    component: () => import("/app/pages/epargne/epargne-omra.vue")
  },
  {
    name: "omra-ramadhan-slug",
    path: "/omra-ramadhan/:slug()",
    meta: _91slug_93vctN6IPkhTtsKSw_rWDVALZhpYyVeHlt95HPYH09Z4YMeta || {},
    component: () => import("/app/pages/omra-ramadhan/[slug].vue")
  },
  {
    name: "politique-de-cookies",
    path: "/politique-de-cookies",
    component: () => import("/app/pages/politique-de-cookies.vue")
  },
  {
    name: "questions-frequentes",
    path: "/questions-frequentes",
    meta: questions_45frequentesmwvxeE2ykH2B_X5YHR7wHbkIU9CaA8TcdiBlwnNPfNMMeta || {},
    component: () => import("/app/pages/questions-frequentes.vue")
  },
  {
    name: "admin-documents",
    path: "/admin/documents",
    meta: {"middleware":"staff-only"},
    component: () => import("/app/pages/admin/documents/index.vue")
  },
  {
    name: "admin-travelers",
    path: "/admin/travelers",
    meta: { ...(indexuBkMWcMWr6xPqW8qWIvNzR0D609ZZtAyWsLh6HXZozkMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/travelers/index.vue")
  },
  {
    name: "booking-manager-guide",
    path: "/booking-manager/guide",
    meta: guideo0pUfMJYZ_mKgSaSwleIWqrfoYz0I0_qB6Yb_z5UsboMeta || {},
    component: () => import("/app/pages/booking-manager/guide.vue")
  },
  {
    name: "booking-manager",
    path: "/booking-manager",
    meta: { ...(indexmt6iy8CM59ezs_8QFp3zZkDWHRxZ_Dt3EOEz0KMFaoUMeta || {}), ...{"middleware":"booking-manager"} },
    component: () => import("/app/pages/booking-manager/index.vue")
  },
  {
    name: "dashboard-orders-id",
    path: "/dashboard/orders/:id()",
    meta: _91id_93HPlW04n38G_5_k3Fl9ZCKtSkx8KeN3rGqWWc3925YJgMeta || {},
    component: () => import("/app/pages/dashboard/orders/[id].vue")
  },
  {
    name: "admin-departure-hotels",
    path: "/admin/departure-hotels",
    meta: { ...(departure_45hotelsGc7NTmm4oO_f_TkHUpXhCwQM8IrsGa2AZPg_6hbygCAMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/departure-hotels.vue")
  },
  {
    name: "admin-departures",
    path: "/admin/departures",
    meta: { ...(indexC_ylYmZAB8Q5FrKxhPQ0oVn4MXN0FPesvcqKx_2fllUMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/app/pages/admin/departures/index.vue")
  },
  {
    name: "booking-manager-guides",
    path: "/booking-manager/guides",
    meta: guidesYHorA3JJ1eV2SJp_VBZmBlR93wwW1oXNJfoRdzB_GTcMeta || {},
    component: () => import("/app/pages/booking-manager/guides.vue")
  },
  {
    name: "dashboard-dossier-id",
    path: "/dashboard/dossier/:id()",
    meta: _91id_93KKcURwP6wpHAdKGQUzolVZWAvZhMFoWQ8KfpHYG84rQMeta || {},
    component: () => import("/app/pages/dashboard/dossier/[id].vue")
  },
  {
    name: "dashboard-orders",
    path: "/dashboard/orders",
    meta: indexkOvzk4Wqpubas5BmXm0ByupmjVQqBS_Yg1ah_XSHMmYMeta || {},
    component: () => import("/app/pages/dashboard/orders/index.vue")
  },
  {
    name: "admin-hotel-assignments",
    path: "/admin/hotel-assignments",
    meta: { ...(hotel_45assignmentsV8ol_Tk3G2vNyTWwR_WnE6Dk9BzAezZJN_0DScKcEhkMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/hotel-assignments.vue")
  },
  {
    name: "booking-manager-coupons",
    path: "/booking-manager/coupons",
    meta: { ...(couponsdUiqFCMDyn3uLCl0UMgt_RBYg4qeTVs_aw3NE_VHR1YMeta || {}), ...{"middleware":"booking-manager-only"} },
    component: () => import("/app/pages/booking-manager/coupons.vue")
  },
  {
    name: "booking-manager-profile",
    path: "/booking-manager/profile",
    meta: profileG3HeS8clMJ8_5GYBbBIpsfraDhh8jTDMbd4p2qJwTZUMeta || {},
    component: () => import("/app/pages/booking-manager/profile.vue")
  },
  {
    name: "dashboard-notifications",
    path: "/dashboard/notifications",
    meta: notificationsOf_UNAu7opNvb7bZhEzgiNcnefyxcJSYDqKrGSibnQQMeta || {},
    component: () => import("/app/pages/dashboard/notifications.vue")
  },
  {
    name: "booking-manager-packages",
    path: "/booking-manager/packages",
    meta: packages30l6sBzRUmjx4hTywKoRV0gOzn_y99_NCBt_mHp5tM4Meta || {},
    component: () => import("/app/pages/booking-manager/packages.vue")
  },
  {
    name: "dashboard-travelers-id",
    path: "/dashboard/travelers/:id()",
    meta: _91id_93Dr03uygKGplV_dpE9sB8_jBzBR69dNpfLlWtlfmOTJoMeta || {},
    component: () => import("/app/pages/dashboard/travelers/[id].vue")
  },
  {
    name: "dashboard-documents",
    path: "/dashboard/documents",
    meta: indexd_31UrK0larHekyt8oc8pkppJ8g6E1YuCF8wPuQcQSQMeta || {},
    component: () => import("/app/pages/dashboard/documents/index.vue")
  },
  {
    name: "dashboard-travelers",
    path: "/dashboard/travelers",
    meta: indexZ4zZlupNsyy5B7c0AnnGfrgRGQm6pEVPYYjvX10CkEEMeta || {},
    component: () => import("/app/pages/dashboard/travelers/index.vue")
  },
  {
    name: "admin-hotel-assignments-old",
    path: "/admin/hotel-assignments-old",
    meta: { ...(hotel_45assignments_45old0wncN4TyXcYYjK35OdJREINJCLaKNdU1_kLYNh6cnkEMeta || {}), ...{"middleware":"admin-only"} },
    component: () => import("/app/pages/admin/hotel-assignments-old.vue")
  },
  {
    name: "booking-manager-orders-id",
    path: "/booking-manager/orders/:id()",
    meta: _91id_93vRf60Bqh9JWMgUARg_XTn5HeUxRI3Atxv7dBas134WMMeta || {},
    component: () => import("/app/pages/booking-manager/orders/[id].vue")
  },
  {
    name: "booking-manager-orders",
    path: "/booking-manager/orders",
    meta: indexqYBc0kRKjU6tTnunWrOk2rhdTpmtLf5pcsdJ6ajGRhQMeta || {},
    component: () => import("/app/pages/booking-manager/orders/index.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/app/pages/politique-de-confidentialite.vue")
  },
  {
    name: "booking-manager-notifications",
    path: "/booking-manager/notifications",
    meta: notificationsIVb9miuOFMMf4CPWneiN3Pb_DF_mQQNKGca9kds6_ooMeta || {},
    component: () => import("/app/pages/booking-manager/notifications.vue")
  },
  {
    name: "conditions-generales-de-vente",
    path: "/conditions-generales-de-vente",
    component: () => import("/app/pages/conditions-generales-de-vente.vue")
  },
  {
    name: "booking-manager-travelers-id",
    path: "/booking-manager/travelers/:id()",
    meta: _91id_93KIZt2_DN5fUcPrA3wUm6AOx1TEdw2yjNdWCq4VFyAksMeta || {},
    component: () => import("/app/pages/booking-manager/travelers/[id].vue")
  },
  {
    name: "booking-manager-documents",
    path: "/booking-manager/documents",
    component: () => import("/app/pages/booking-manager/documents/index.vue")
  },
  {
    name: "booking-manager-travelers",
    path: "/booking-manager/travelers",
    meta: indexcOc1u1ZSjUtcvVkEXCdvjzJOyQbQq2CPBQzbZtcC8tcMeta || {},
    component: () => import("/app/pages/booking-manager/travelers/index.vue")
  },
  {
    name: "booking-manager-departures",
    path: "/booking-manager/departures",
    meta: indexxTRY7vN5gRH4kR71CyuhZZJGojRd59SeRUhIhzO3n1cMeta || {},
    component: () => import("/app/pages/booking-manager/departures/index.vue")
  },
  {
    name: "booking-manager-hotel-assignments",
    path: "/booking-manager/hotel-assignments",
    meta: hotel_45assignmentsioSk6CxK9qSjHW_yRw7mHsg1pwECbfpjKrGyWwG3Fz0Meta || {},
    component: () => import("/app/pages/booking-manager/hotel-assignments.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/app/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-departures-id-room-assignments",
    path: "/admin/departures/:id()/room-assignments",
    meta: { ...(room_45assignmentsQqd6myEJMcgde6CkuEKY2fHVBInBG_d_vE2kywc89tsMeta || {}), ...{"middleware":["admin-only"]} },
    component: () => import("/app/pages/admin/departures/[id]/room-assignments.vue")
  },
  {
    name: "booking-manager-departures-id-room-assignments",
    path: "/booking-manager/departures/:id()/room-assignments",
    meta: room_45assignmentsHEANVeD45gCLwQzrmQ8q7Z2ejqp8eQRs8SZO8PfoiQwMeta || {},
    component: () => import("/app/pages/booking-manager/departures/[id]/room-assignments.vue")
  }
]